import { useState } from "react";
import { AlertFormData, AlertCreateDto } from "../../../types/alert";
import AlertForm from "./AlertForm";
import { useCreateAlert } from "../../../queries/alerts";
import { queryClient } from "../../../queries/client";
import { toast } from "react-toastify";

interface AlertWizardProps {
  onClose: () => void;
}

export default function AlertWizard({ onClose }: AlertWizardProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: createAlert } = useCreateAlert();

  const handleSubmit = async (formData: AlertFormData) => {
    setIsLoading(true);
    try {
      const alertCreateDto: AlertCreateDto = {
        name: formData.name,
        condition: formData.condition,
        threshold: parseFloat(formData.threshold),
        thresholdMax: formData.thresholdMax
          ? parseFloat(formData.thresholdMax)
          : undefined,
        primaryCooldown: parseInt(formData.primaryCooldown) || 60,
        cooldown: parseInt(formData.cooldown) || 1800,
        primaryEmails: formData.primaryEmails,
        secondaryEmails: formData.secondaryEmails,
        parameterId: formData.parameterId,
      };
      createAlert(alertCreateDto, {
        onSuccess: () => {
          toast("Alert added successfully", {
            type: "success",
            autoClose: 2000,
          });

          queryClient.invalidateQueries({ queryKey: ["get-location-devices"] });

          onClose();
        },
        onError: (error: any) => {
          toast(error?.response?.data?.errorMessage || "Failed to add alert", {
            type: "error",
            autoClose: 2000,
          });
        },
      });
    } catch (error) {
      console.error("Error creating alert:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <div className="h-full">
      <AlertForm
        mode="create"
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isLoading={isLoading}
      />
    </div>
  );
}
